import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLDialogElement> {
  connect(): void {
    this.element.showModal()
  }
}
